"use client";

/**
 * Acceso 1.2 — "Tu número y listo": teléfono + envío del código por WhatsApp.
 */

import { Suspense, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";

import { IconoAtras, IconoWhatsApp } from "@/components/app/iconos";

function FormularioTelefono() {
  const router = useRouter();
  const search = useSearchParams();
  const next = search.get("next") ?? "";
  const [telefono, setTelefono] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);

  async function enviar() {
    if (cargando) return;
    setError(null);
    setCargando(true);
    try {
      const res = await fetch("/api/auth/otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ telefono }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError(data.error ?? "No pudimos enviar el código. Intenta de nuevo.");
        return;
      }
      try {
        sessionStorage.setItem("fz_tel", telefono);
        if (data.devCode) sessionStorage.setItem("fz_devcode", data.devCode);
        else sessionStorage.removeItem("fz_devcode");
      } catch {}
      router.push(`/acceso/codigo${next ? `?next=${encodeURIComponent(next)}` : ""}`);
    } catch {
      setError("Sin conexión. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="anim-bz-in relative min-h-(--alto-app) bg-[linear-gradient(180deg,#1E8A40_-15%,#082411_136%)] px-[34px]">
      <button
        type="button"
        aria-label="Volver"
        onClick={() => router.back()}
        className="absolute top-[42px] left-[30px] flex h-[38px] w-[38px] items-center justify-center rounded-xl border border-white/35"
      >
        <IconoAtras color="#fff" />
      </button>

      <div className="pt-[170px]">
        <h1 className="max-w-[290px] font-app text-3xl leading-[35px] font-black text-white">
          Tu número y listo
        </h1>
        <p className="mt-3 max-w-[280px] text-[15px] leading-[22px] text-white/75">
          Te enviamos un código por WhatsApp. Sin contraseñas que olvidar.
        </p>

        <div className="mt-9 flex h-[68px] items-center gap-2.5 rounded-[30px] bg-white px-6">
          <span className="font-app text-lg font-semibold text-tinta">+593</span>
          <span className="h-[26px] w-px bg-black/10" />
          <input
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && void enviar()}
            placeholder="99 123 4567"
            inputMode="tel"
            autoFocus
            className="min-w-0 flex-1 border-0 bg-transparent font-app text-lg font-medium text-tinta outline-0 placeholder:text-tinta/40"
          />
        </div>

        {error && (
          <p className="mt-3 rounded-2xl bg-white/10 px-4 py-2 text-sm text-[#FFD9D2]">
            {error}
          </p>
        )}

        <button
          type="button"
          onClick={() => void enviar()}
          disabled={cargando}
          className="mt-4 flex h-[68px] w-full items-center justify-center gap-2.5 rounded-[30px] bg-lima font-app text-lg font-semibold text-bosque transition active:scale-[.98] disabled:opacity-60"
        >
          <IconoWhatsApp color="#082411" />
          {cargando ? "Enviando…" : "Enviar código"}
        </button>

        <p className="mt-5 max-w-[300px] text-xs leading-[18px] text-white/55">
          Al continuar aceptas nuestros <span className="text-lima">términos</span> y
          la <span className="text-lima">política de privacidad</span>.
        </p>
      </div>
    </div>
  );
}

export default function PaginaAcceso() {
  return (
    <Suspense>
      <FormularioTelefono />
    </Suspense>
  );
}
